export const ALREADY_SUBMITTED_MESSAGE = 'This registration has already been submitted or is no longer available.';

const DEFAULT_MESSAGES: { [status: number]: string } = {
  400: 'The information provided is invalid. Please review the form and try again.',
  401: 'This registration link is not valid. Please use the link from your invitation email.',
  409: ALREADY_SUBMITTED_MESSAGE,
};

const GENERIC_MESSAGE = 'We were unable to complete your registration. Please try again later.';

/** Builds a user-facing message from an HTTP/API error raised while submitting a supplier registration. */
export function getRegistrationErrorMessage(err: any): string {
  const serverMessage = extractServerMessage(err);
  if (serverMessage) {
    return serverMessage;
  }

  return DEFAULT_MESSAGES[err?.status] ?? GENERIC_MESSAGE;
}

function extractServerMessage(err: any): string | null {
  const raw = err?.response;
  if (typeof raw !== 'string' || raw === '') {
    return null;
  }

  try {
    const body = JSON.parse(raw);
    const message = body?.message ?? body?.detail ?? body?.title;
    return typeof message === 'string' && message.trim() !== '' ? message : null;
  } catch {
    // Non-JSON body: only trust short plain-text messages, never HTML error pages.
    return raw.length <= 200 && !raw.trim().startsWith('<') ? raw : null;
  }
}
